module.exports = __webpack_public_path__ + "static/media/user_experience.91559c21.svg";